// @USAGE
// const dispatch = useDispatch();
// const account_reducer = useSelector(state => state.account_reducer);
// > set: dispatch(account_actions.{function});
// > get: account_reducer.{key_name_of_state};

import {createSlice} from "@reduxjs/toolkit";

const init_state = {
    is_login: false, // 사실은 token 이 있는지 없는지에 대한 값이다 (without validation check)

    info: {}, // reference of user graph (data.account)
    with_detail_info: false, // info 객체가 detail 값을 포함했는지 여부 (account_detail_serializer 확인)

    // access tokens
    token: null, // response 참고

    require_login: 0,

    company: {},
};

const account_slice = createSlice({
    name: "account",
    initialState: init_state,
    reducers: {
        doLogin(state, {payload}) {
            state.is_login = true;
            state.info = payload.info;
            state.token = payload.token;
            state.with_detail_info = payload.with_detail_info;
            state.company = payload.company;
        },
        doLogout(state) {
            state.is_login = false;
            state.info = init_state.info;
            state.token = init_state.token;
            state.company = init_state.company;
        },
        setInfo(state, {payload}) {
            state.info = payload.info;
            state.with_detail_info = payload.with_detail_info;
        },
        onRequireLogin(state) {
            state.require_login += 1;
        },
        resetAll(state) {
            return (state = init_state);
        },
    },
});

export const account_actions = account_slice.actions;
export default account_slice.reducer;
